import React from 'react';
import ContestLanding from '../common/ContestLanding';
import HmAjax from '../../util/HmAjax';
import HmEventRegistry from '../../model/HmEventRegistry';

class ContestDownloads extends ContestLanding{
    constructor(props) {
        super(props);
        this.state = {
            dataLoaded:false
        };
        this.dashboardDropDownKey = "homeDropdown";
        this.setChild(this,"CONTEST");

        this.contest_downloads = null;

        this.picUrl = {
            "picture_as_pdf" : '/images/contest/downloads/pdf_icon.png',
            "library_books" : '/images/contest/downloads/word_icon.png',
            "add_to_photos" : '/images/contest/downloads/xls_icon.png',
            "default_icon" : '/images/contest/downloads/default_icon.png'
        }
    }
    
    componentDidMount(){
        super.componentDidMount();
        this.loadDownloads();
        HmEventRegistry.fireEvent("INITIATE_GA");
        HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
    }

    getFileBasePath(){
        return this.getUrlFor("DOWNLOAD_USEFUL_DOCS");
    }

    openFile(evt){
        if(evt.currentTarget && evt.currentTarget.dataset && evt.currentTarget.dataset.file){
            console.log("Filename to be opened :" , evt.currentTarget.dataset);

            let fileBasePath = this.getFileBasePath();

            if(fileBasePath && fileBasePath.length > 0){
                let fileNameWithPath = (fileBasePath.endsWith("/")) ? fileBasePath + evt.currentTarget.dataset.file : fileBasePath + "/" + evt.currentTarget.dataset.file;

                window.open(fileNameWithPath,"_blank");    
            }else{
                console.warn("cannot download file : N/A");
            }            
        }        
    }

    loadDownloads(){
        let me = this;
        let contestId = (this.getSelectedContestGroup()) ? this.getSelectedContestGroup().toUpperCase() : null;
        
        if(!contestId){
          return;
      }

      let success = (resp) => {
          if(resp && resp.contest_downloads){
           me.contest_downloads = resp.contest_downloads;

           me.setState({dataLoaded: true})
       }
   }

   let failure = (err) => {
      console.error("Error occurred while getting downloads from json : ", err);
  }
  new HmAjax(this.getUriFor("GET_CONTEST_STEPS_JSON").replace("CP_DOMAIN",this.getBasePath()).replace("{#contestId}",contestId)).get(success, failure);
}

renderdownloadContent(){
    let fileType = {
        ".pdf":{
            "img":this.picUrl["picture_as_pdf"]
        },
        ".xls":{
            "img":this.picUrl["add_to_photos"]
        },
        ".xlsx":{
            "img":this.picUrl["add_to_photos"]
        },
        ".doc":{
            "img":this.picUrl["library_books"]
        },
        ".docx":{
            "img":this.picUrl["library_books"]
        }
    }
    if(this.state.dataLoaded && this.contest_downloads){
        return (<div className="dwnldcont"><h3>Resources</h3>
        {
            this.contest_downloads.map((download,index)=>{
                if(download && download.text && !download.hidden){
                    let tempArr = (download.file) ? (download.file).match(/.[a-zA-Z]+/g) || [] : [];
                    let fileExt = (tempArr && tempArr.length > 0 && tempArr[tempArr.length - 1]) ? tempArr[tempArr.length - 1].toLowerCase() : ".pdf";
                    
                    let fileImgType = (fileType[fileExt] && fileType[fileExt]["img"]) ? fileType[fileExt]["img"] : this.picUrl["default_icon"];
                   // console.log("fileImgType ",fileImgType);
                   if(download.file){
                     return (
                    <div style={{"cursor":"pointer"}} key={index} className="dwnldcontbox" data-ga={"Resources - " + download.file }  data-file={download.file} onClick={this.openFile.bind(this)}>
                    <div>
                        <img src={fileImgType}  alt={download.text} />
                    </div>
                    <div className="dwntxt">
                    {download.text}
                    </div>
                  
                        
                    <div><i className="material-icons">get_app</i></div>
              
                               
                    </div>
                    )
                }    
                }
               })
        }
        </div>
        )
    }else{
      return super.render(
      <div> {this.showLoader()} </div>
      )
  }
}

render(){
    if(this.state.dataLoaded){
        return super.render(
        <div className="HomeComponent">
        { this.renderdownloadContent()}
        </div>
        )
    }else{
        return super.render(this.showLoader())
    }
}

}

export default ContestDownloads;


// WEBPACK FOOTER //
// ./src/views/contest/ContestDownloads.js